import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { ErrorBoundary } from "./ErrorBoundary";
import { CommandPalette, useCommandPaletteHotkey } from "./CommandPalette";
import { UpdateNotice } from "./UpdateNotice";

/**
 * Uygulama kabuğu: sol menü + üst çubuk + içerik.
 * Eski `sidebar.php` + `sidebar_footer.php` ikilisinin karşılığı; ölçüler
 * (lg:pl-72, h-16 üst çubuk, py-8 içerik) bilerek korundu.
 */
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [paletteOpen, setPaletteOpen] = useState(false);
  const location = useLocation();
  const openPalette = useCallback(() => setPaletteOpen(true), []);
  useCommandPaletteHotkey(openPalette);

  // Rota değişince mobil çekmece kapanır (tablette açık kalıyordu).
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname, location.search]);

  return (
    <div className="min-h-full">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      <UpdateNotice />

      <div className="lg:pl-72">
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} onOpenPalette={openPalette} />

        <main id="icerik" className="py-6 sm:py-8">
          {/* ★ GENİŞ EKRANDA SINIR GEVŞETİLİR.
              İçerik 1280px'e kilitliydi ve yan menü o sınırın DIŞINDA 288px yer
              kaplıyordu; 1920px'lik bir ofis monitöründe sağda ~360px kalıcı
              olarak boş kalıyor, buna karşın yoğun tablolar (Kullanıcılar,
              Denetim Kaydı, Parça Yönetimi) yatay kayıyordu. Okunabilirlik için
              üst sınır tamamen kaldırılmaz; 1600px'e çıkarılır. */}
          <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8">
            {/* Bir ekranın çökmesi tüm paneli düşürmesin. */}
            <ErrorBoundary where={location.pathname}>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;
